module.exports = __webpack_public_path__ + "./sean-illustration_766bc025bb8b865e2ff66b82ebd9b6b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2016/sean-illustration.png
// module id = 437
// module chunks = 0